import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39a5d645"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a5d645')) {
      api.createRecord('39a5d645', component.options)
    } else {
      api.reload('39a5d645', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39a5d645", function () {
      api.rerender('39a5d645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/callPlayerCom/index.vue"
export default component.exports